import React, { Fragment, useState, useEffect } from "react";
import AllAccounts from "../../components/Accounts/AllAccounts.jsx";
import { Card } from "primereact/card";
import { BreadCrumb } from "primereact/breadcrumb";
import Title from "../../components/Functions/Title.jsx";
import { ProgressSpinner } from "primereact/progressspinner";
import { SearchAccount } from "../../services/AccountService.js";
import AddAccount from "../../components/Accounts/AddAccount.jsx";
import { Dialog } from "primereact/dialog";

export default function Order({ t }) {
  const [data, setData] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [createDialogAccount, setCreateDialogAccount] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const [filters, setFilters] = useState({
    page: currentPage,
    size: itemsPerPage,
    accountId: undefined,
    email: undefined,
  });

  //Call to action
  const toggleCreateAccount = () => {
    setCreateDialogAccount(!createDialogAccount);
  };
  const items = [{ label: t("accounts") }];
  const home = {
    icon: "pi pi-home",
    url: "/",
  };

  const refreshData = async () => {
    await SearchAccount({ ...filters }).then((res) => {
      setData(res.data);
      setLoaded(true);
    });
  };
  useEffect(() => {
    refreshData();
  }, [currentPage, itemsPerPage, filters]);

  return (
    <Fragment>
      <Title title={t("accountsList")} />
      <BreadCrumb model={items} home={home} />

      <Dialog
        visible={createDialogAccount}
        style={{ width: "50vw", height: "100vh" }}
        modal
        onHide={toggleCreateAccount}
      >
        <AddAccount
          t={t}
          setCreateDialogAccount={setCreateDialogAccount}
          refreshData={refreshData}
          toggleCreateAccount={toggleCreateAccount}
          state={{ data, setData }}
        />
      </Dialog>

      <Card>
        {loaded ? (
          <AllAccounts
            t={t}
            toggleCreateAccount={toggleCreateAccount}
            filtersState={{ filters, setFilters }}
            data={data}
            pageState={{
              currentPage,
              itemsPerPage,
              setCurrentPage,
              setItemsPerPage,
            }}
          />
        ) : (
          <Fragment>
            <div className="flex justify-content-center">
              <ProgressSpinner />
            </div>
          </Fragment>
        )}
      </Card>
    </Fragment>
  );
}
